function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconGift = function IconGift(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    width: "89",
    height: "100",
    viewBox: "0 0 89 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3728_10691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.63281 23.584H87.3685V87.6865C87.3685 93.5893 82.5726 98.3703 76.6515 98.3703H12.3498C6.42865 98.3703 1.63281 93.5893 1.63281 87.6865V23.584Z",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5 98.3703V23.584",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4988 4.88742C42.0354 8.46648 44.5003 15.5712 44.5003 23.584C36.4626 23.584 29.2554 21.4205 25.7189 17.8415C22.1823 14.2624 22.1823 8.46648 25.7189 4.88742C29.2554 1.30836 34.9622 1.30836 38.4988 4.88742Z",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5015 4.88742C46.9649 8.46648 44.5 15.5712 44.5 23.584C52.5377 23.584 59.7449 21.4205 63.2815 17.8415C66.8181 14.2624 66.8181 8.46648 63.2815 4.88742C59.7449 1.30836 54.0381 1.30836 50.5015 4.88742Z",
    stroke: "currentColor",
    strokeWidth: "3"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3728_10691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "89",
    height: "100",
    fill: "white"
  }))));
};